export default "__VITE_ASSET__DgDYLPAE__"